import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// send cookies (session_token) with every request
axios.defaults.withCredentials = true;

// Build absolute media URL from a backend-relative path (e.g. /api/uploads/..)
export const mediaUrl = (path) => (path && path.startsWith('http') ? path : `${BACKEND_URL}${path}`);

const TOKEN_KEY = 'citytoon_admin_token';
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const authHeaders = () => ({ Authorization: `Bearer ${getToken()}` });

// Identifiant visiteur pseudonyme (aucune donnée perso, pas d'IP). Généré/persisté localement.
const VISITOR_KEY = 'citytoon_visitor_id';
export const getVisitorId = () => {
  let v = localStorage.getItem(VISITOR_KEY);
  if (!v) {
    v = (crypto.randomUUID ? crypto.randomUUID() : `v-${Date.now()}-${Math.random().toString(36).slice(2)}`);
    localStorage.setItem(VISITOR_KEY, v);
  }
  return v;
};

export const adminLogin = async (password) => {
  const { data } = await axios.post(`${API}/admin/login`, { password });
  setToken(data.token);
  return data;
};

export const adminVerify = async () => {
  const { data } = await axios.get(`${API}/admin/verify`, { headers: authHeaders() });
  return data;
};

export const getPlanches = async (webtoonId) => {
  const { data } = await axios.get(`${API}/webtoons/${webtoonId}/planches`);
  return data;
};

export const uploadPlanche = async (webtoonId, file, onProgress) => {
  const form = new FormData();
  form.append('file', file);
  const { data } = await axios.post(`${API}/webtoons/${webtoonId}/planches`, form, {
    headers: { ...authHeaders(), 'Content-Type': 'multipart/form-data' },
    onUploadProgress: (e) => {
      if (onProgress && e.total) onProgress(Math.round((e.loaded / e.total) * 100));
    },
  });
  return data;
};

export const deletePlanche = async (webtoonId, plancheId) => {
  const { data } = await axios.delete(`${API}/webtoons/${webtoonId}/planches/${plancheId}`, { headers: authHeaders() });
  return data;
};

export const reorderPlanches = async (webtoonId, orderedIds) => {
  const { data } = await axios.put(`${API}/webtoons/${webtoonId}/planches/reorder`, { orderedIds }, { headers: authHeaders() });
  return data;
};

// ---------- Google auth (Emergent) ----------
export const exchangeSession = async (sessionId) => {
  const { data } = await axios.post(`${API}/auth/session`, {}, { headers: { 'X-Session-ID': sessionId } });
  return data;
};

export const fetchMe = async () => {
  const { data } = await axios.get(`${API}/auth/me`);
  return data;
};

export const logoutApi = async () => {
  const { data } = await axios.post(`${API}/auth/logout`, {});
  return data;
};

// ---------- User library sync ----------
export const getLibrary = async () => {
  const { data } = await axios.get(`${API}/me/library`);
  return data;
};

export const putLibrary = async (favorites, progress) => {
  const { data } = await axios.put(`${API}/me/library`, { favorites, progress });
  return data;
};

// ---------- Custom webtoons (Admin+) ----------
export const listCustomWebtoons = async () => {
  const { data } = await axios.get(`${API}/webtoons`);
  return data;
};

export const createWebtoon = async (fields, coverFile, onProgress) => {
  const form = new FormData();
  Object.entries(fields).forEach(([k, v]) => form.append(k, v));
  form.append('cover', coverFile);
  const { data } = await axios.post(`${API}/webtoons`, form, {
    headers: { ...authHeaders(), 'Content-Type': 'multipart/form-data' },
    onUploadProgress: (e) => { if (onProgress && e.total) onProgress(Math.round((e.loaded / e.total) * 100)); },
  });
  return data;
};

export const deleteWebtoon = async (webtoonId) => {
  const { data } = await axios.delete(`${API}/webtoons/${webtoonId}`, { headers: authHeaders() });
  return data;
};
